/**
 * Main Styling File for Escape Text Component
 *
 * @author Creator-Solutions -> Owen Burns
 */

import { NavLink as BaseNavLink } from "react-router-dom";

import styled from "styled-components";

const NavButtonCaption = styled(BaseNavLink)`
  color: hsl(320 100% 60%);
`;

const Body = styled.p`
  font-size: 16px;
  color: #fff;
`;

export { NavButtonCaption, Body };
